import App from 'app/src/App'
import { WebAppContextByServiceWorker } from 'app/src/msw/WebAppContextByServiceWorker'
import { isDemoApp } from 'app/src/shared/helpers'
import { WebAppContextProvider } from 'app/src/shared/helpers/context'
import 'app/src/styles/base.css'
import React from 'react'
import ReactDOM from 'react-dom/client'

const useServiceWorker = isDemoApp()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.Suspense fallback='loading'>
    {useServiceWorker ? (
      <WebAppContextByServiceWorker>
        <App />
      </WebAppContextByServiceWorker>
    ) : (
      <WebAppContextProvider>
        <App />
      </WebAppContextProvider>
    )}
  </React.Suspense>,
)
